<template>
  <b-popover
    v-model="showPopover"
    :target="props.idPopover"
    class="custom-popover !tw-border-0"
    :manual="true"
    :placement="props.placement"
    :custom-class="
      customClass
        ? `custom-actions-popover ${customClass}`
        : 'custom-actions-popover'
    "
    :offset="offset"
    :delay="{
      show: 0,
      hide: showAcctionClick ? hide : timeout,
    }"
    @show="handleShow"
    @hidden="$emit('on-hover', false)"
  >
    <div class="tw-flex tw-flex-col last-item">
      <slot />
    </div>
  </b-popover>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const emit = defineEmits(["on-hover"]);
const props = defineProps({
  idPopover: {
    type: String,
    required: true,
  },
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  placement: {
    type: String,
    required: false,
    default: "bottom-start",
  },
  showAcctionClick: { type: Boolean, required: false, default: false },
  showMoreActions: { type: Boolean, required: false, default: false },
  timeout: { type: Number, required: false, default: 1000 },
  offset: { type: Number, required: false, default: 7 },
});
const hide = ref(9999999999999);
const showPopover = ref(false);
const handleShow = () => {
  emit("on-hover", true);
};
watch(
  () => props.showMoreActions,
  (value) => {
    showPopover.value = value;
  },
  { immediate: true },
);
</script>
<style lang="scss">
.last-item > span:last-of-type {
  border-bottom: none;
}
</style>
